import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.5625 2.43628V6.81128H11.1875",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.99995 15.5613C7.79667 15.562 6.61635 15.2319 5.58806 14.607C4.55976 13.9821 3.72306 13.0865 3.16944 12.0181C2.61582 10.9498 2.36659 9.74977 2.44901 8.54932C2.53142 7.34886 2.9423 6.19417 3.63673 5.21149C4.33115 4.22882 5.28239 3.45598 6.38644 2.97748C7.49048 2.49898 8.70484 2.33324 9.89673 2.49838C11.0886 2.66352 12.2122 3.15318 13.1445 3.91382C14.0769 4.67447 14.7822 5.67682 15.1833 6.81128",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgRedo);
export default ForwardRef;
